import { render, staticRenderFns } from "./JobBoardReports.vue?vue&type=template&id=0ff8ec6e&"
import script from "./JobBoardReports.vue?vue&type=script&lang=js&"
export * from "./JobBoardReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports